export default __webpack_public_path__ + "static/media/noun_drag_and_drop.6efafb72.svg";